module.exports = __webpack_public_path__ + "static/media/IMG_3028.3db38228.JPG";